<template>
    <div class="formulario-wrapper">
        <div class="max-w-2xl md:max-w-3xl bg-white mx-auto">
            <h1 class="text-xl uppercase mb-1" v-text="form.title"></h1>
            <p class="text-sm uppercase mb-3 text-gray-600" v-text="form.desc"></p>
            <form id="formulario-impacto" class="mt-12" @submit.prevent="submit"
                  @keydown="error.clear($event.target.name)" @click="error.clear($event.target.name)">
                <the-field v-bind:key="index"
                           v-for="(field, index) in fields"
                           v-model="formulario[field.name].value"
                           v-bind:error="error"
                           v-bind:field="field"></the-field>
                <button class="w-full md:w-auto block ml-auto bg-pink-500 text-sm rounded-full text-white px-10 py-2 md:text-base font-bold" type="submit">
                    Avançar
                </button>
            </form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapState} from "vuex";
    import Error from "@/includes/Error";
    import TheField from "@/components/TheField";
    import FormularioUtil from "@/includes/util/FormularioUtil";
    import animateScrollTo from "animated-scroll-to";

    export default Vue.extend({
        components: {TheField},
        computed: mapState({
            form: state => state.formulario.impacto,
            fields: state => state.formulario.impacto.fields
        }),
        data() {
            return {
                formulario: [],
                error: new Error()
            }
        },
        created() {
            this.formulario = FormularioUtil.createVueModelsForVue(this.fields)
            const alreadyLoaded = this.fields.find(field => false === field.isEmpty())
            if(alreadyLoaded) {
                animateScrollTo(0);
            }
        },
        methods: {
            submit() {
                this.$store.dispatch('salvarFormularioImpacto', Object.values(this.formulario))
                    .then(() => this.$router.push({name: 'CadastroImpactoEconomico'}))
                    .catch(error => this.error = error)
            }
        }
    })
</script>